<template>
  <div
    class="lego-dropdown lego-input"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight]"
    v-click-outside="toggleItemOuter"
  >
    <div class="lego-dropdown__title" @click="toggleItem">
      <div
        class="lego-dropdown__selected ellipsis"
        :style="[dropdownTitleStyle, selected.length === 0 && { color: 'rgb(165, 167, 173)' }]"
        v-lego-tooltip:ellipsis="getSelectedItemText"
      >
        {{ getSelectedItemText }}
      </div>
      <lego-icon-wrapper style="width: 16px; margin-left: 12px">
        <lego-icon class="lego-dropdown__icon" icon="expand_menu" size="10px" :style="caretStyle" />
      </lego-icon-wrapper>
    </div>
    <div class="lego-dropdown__downwrap" v-if="isItemShowing">
      <div class="lego-dropdown__tags">
        <div class="lego-dropdown__selectall-wrap">
          <div
            class="lego-dropdown__item lego-dropdown__selectall"
            v-show="selectAll"
            @click="clickSelectAll"
          >
            <lego-checkbox
              :indeterminate="selectAllChecked && selectAllCheckedIcon === 'indeterminate'"
              :checked="selectAllChecked"
              :checked-icon="selectAllCheckedIcon"
              @click="clickSelectAll"
              >{{ $t('label.selectAll') }}</lego-checkbox
            >
          </div>
          <!-- <div
            class="lego-dropdown__item lego-dropdown__selectall"
            v-show="selectAll" @click="clickSelectAll">
            <lego-checkbox
              :checked="selectAllChecked"
              :checked-icon="selectAllCheckedIcon"
              @click="clickSelectAll">전체 선택</lego-checkbox>
          </div> -->
        </div>

        <div class="lego-dropdown__items">
          <!-- <div class="lego-dropdown__items" :style="[dropdownWidth]"> -->
          <div
            class="lego-dropdown__item"
            v-for="(item, idx) in items"
            :key="idx"
            @click="onClickItem(item)"
          >
            <div class="lego-dropdown__label">
              <lego-checkbox :value="item" :checked="selected" @click="onClickItem(item)">
                <!-- {{getText(item)}} -->
                <!-- {{'키값: 밸류값'}} -->
                {{ `${item.key}` }}
              </lego-checkbox>
            </div>
          </div>
        </div>
        <!--<div class="lego-dropdown__apply lego-dropdown__apply_pos" v-show="applyBtn" :style="[dropdownWidth]">-->
        <div class="lego-dropdown__apply-wrap">
          <div class="lego-dropdown__apply lego-dropdown__apply_pos" v-show="applyBtn">
            <lego-button @click="onApplyClick">적용</lego-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const UNSELECT_DROPDOWN_TITLE = '선택';

import legoDropdown from '@/lego-component/components/element/legoDropdown/legoDropdown.vue';
// lego-multi-dropdown은 lego-dropdown을 상속받은 컴포넌트 입니다. lego-dropdown의 모든 속성을 그대로 사용합니다.
// #lego-multi-dropdown is a component that inherits lego-dropdown. Accept all the properties of lego-dropdown.
export default {
  name: 'scpm-stats-dropdown',
  extends: legoDropdown,
  emits:['tag-input'],
  props: {
    // $ver: v0.1.2
    // $v-model
    // 드랍다운 리스트의 선택된 값 입니다.
    // #The selected value in the drop-down list.
    value: {
      type: Array,
      validator: function (val) {
        return Array.isArray(val);
      },
      default: () => []
    },
    // $ver: v0.1.2
    // Apply 버튼을 표시합니다.
    // #Display the Apply button.
    // $default: false
    applyBtn: { type: Boolean, default: false },

    // $ver: v0.1.2
    // Select All 기능을 표시합니다.
    // #Displays the Select All function.
    // $default: false
    selectAll: { type: Boolean, default: false }
  },
  data() {
    return {
      selected: [],
      prevSelected: []
    };
  },
  computed: {
    getSelectedItemText() {
      if (this.selected.length === 0) {
        return this.$t('label.notSelect');
      } else {
        let itemText = [];
        this.selected.forEach((item) => {
          if (typeof this.itemText === 'function') {
            itemText.push(this.itemText(item));
          } else {
            // itemText.push(item[this.itemText]);
            //itemText.push(item.key.concat(item.value ? `:${item.value}` : ''));
            itemText.push(item.key);
          }
        });
        return itemText.sort().join(', ');
      }
    },
    selectAllChecked() {
      return this.selected.length > 0;
    },
    selectAllCheckedIcon() {
      return this.selected.length === this.items.length ? 'checked' : 'indeterminate';
    }
  },
  watch: {
    isItemShowing() {
      if (this.applyBtn && this.isItemShowing) {
        this.prevSelected = this.selected.slice();
      }
    },
    value() {
      if (!_.isEqual(this.selected, this.value)) {
        this.selected = this.value.slice();
      }
    }
  },
  mounted() {
    this.selected = this.value.slice();
  },
  methods: {
    onClickItem(item) {
      let index = _.findIndex(this.selected, item);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(item);
      }
      //console.log(">>> selected:: ", this.selected);
      if (!this.applyBtn) {
        this.$emit('tag-input', this.selected.slice());
      }
    },
    toggleItem() {
      this.resetSelected();
      this.isItemShowing = !this.isItemShowing;
    },
    toggleItemOuter() {
      this.resetSelected();
      this.isItemShowing = false;
    },
    resetSelected() {
      if (this.applyBtn && this.isItemShowing) {
        this.selected = this.prevSelected.slice();
      }
    },
    onApplyClick() {
      this.$emit('tag-input', this.selected.slice());
      this.isItemShowing = false;
    },
    clickSelectAll() {
      if (this.selected.length === this.items.length) {
        this.selected.splice(0, this.selected.length);
      } else {
        this.selected = this.items.slice();
      }
      if (!this.applyBtn) {
        this.$emit('tag-input', this.selected.slice());
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lego-dropdown {
  min-width: 80px;
  width: 100%;
  &__title {
    border-radius: 2px;
    .lego-dropdown__selected {
      width: calc(100% - 24px);
      span {
        display: inline-block;
        @include ellipsis;
      }

      &.placeholder {
        color: $color--ui06;
      }
    }
  }

  &__title-icon {
    .lego-dropdown__icon {
      font-size: 12px;
    }
  }

  .lego-dropdown__title {
    &:focus {
      border: $lego-dropdown__title__border;
    }
    &:hover {
      border-color: $lego-dropdown__title__border--focus;
    }
  }

  &--borderless {
    width: auto;
    min-width: auto;
    .lego-dropdown__title {
      border: 0 !important;

      .lego-dropdown__selected {
        flex-grow: 1;
      }
    }

    &.lego-dropdown--disabled {
      .lego-dropdown__title {
        background: none !important;
      }
    }
  }

  &--readonly {
    pointer-events: none;
    cursor: default;
    .lego-dropdown__title {
      border: $lego-dropdown__title__border--disabled;
      background-color: $lego-dropdown__title__background-color--readonly;
    }
  }

  &--small {
    min-width: $lego-dropdown__min-width--small;
    .lego-dropdown__title-icon {
      .lego-dropdown__icon {
        font-size: 10px;
      }
    }
  }
}

::v-deep .lego-button--border.lego-button--default {
  font-weight: 700;
  background-color: #364fc7;
  border-color: #364fc7;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  border-radius: 2px;
  height: 24px;
  min-width: 70px;
  padding: 0 8px;
  cursor: pointer;

  &:hover {
    background-color: #2b3f9f;
    border-color: #2b3f9f;
  }
}

::v-deep .lego-dropdown__downwrap {
  width: 100%;
}

.lego-dropdown__tags {
  // padding: 0 10px;
  background-color: #ffffff;
  border: 1px solid #a5a7ad;
}
::v-deep .lego-dropdown__item {
  padding: 0 10px 0 10px;
}
::v-deep .lego-dropdown__selectall {
  padding: 8px 0;
  border: 0;
  border-bottom: 1px solid #a5a7ad;
}
::v-deep .lego-dropdown__items {
  border: 0;
  overflow-x: hidden;
}
.lego-dropdown__selectall-wrap,
.lego-dropdown__apply-wrap {
  padding: 0 10px;
}
::v-deep .lego-dropdown__apply {
  border: 0;
  border-top: 1px solid #a5a7ad;
}
::v-deep .lego-button--default:not(.lego-button--loading):hover {
  background-color: #2b3f9f !important;
}
::v-deep .lego-checkbox__label {
  display: block;
  width: calc(100% - 40px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
